import * as React from 'react'
import {useAtom} from 'jotai'
import {useAtomValue} from 'jotai/utils'
import {useActor} from '@xstate/react'
import {useSelector} from 'react-redux'
import Tippy from '@tippyjs/react'
import {useClickAway} from 'react-use'
import ErrorBoundary from 'components/ErrorBoundary'
import IconButton from '@mui/material/IconButton'
import TooltipContent from 'components/PlanTooltipContent'
import {showSitePlanAtom, tourMachineAtom, sidebarAtom} from 'components/jotai'
import {CloseIcon} from 'components/Icons'
import {getFilteredVisited} from 'components/visited/duck'

export default function BjeFreePlan({onClose}) {
  const [showSitePlan, setShowSitePlan] = useAtom(showSitePlanAtom)
  const sidebarOpen = useAtomValue(sidebarAtom)
  const tourService = useAtomValue(tourMachineAtom)
  const [tour] = useActor(tourService)
  const visited = useSelector(getFilteredVisited)
  const primaryColor = '#009FE3'
  const activeStyle = {fill: primaryColor, cursor: 'pointer'}
  const visitedStyle = {border: `1 px solid ${primaryColor}`, cursor: 'pointer'}
  const defaultStyle = {cursor: 'pointer'}

  const ref = React.useRef(null)
  useClickAway(ref, () => {
    setShowSitePlan(false)
  })

  const handleOpen = e => {
    setShowSitePlan(false)
    if (e?.target?.id) {
      const playlistItem = window?.blazeIT?.getPlayListItemByMediaName(
        e.target.id,
      )

      if (playlistItem) {
        window?.blazeIT?.navigateToPlayListItem(playlistItem)
      }
    }
  }

  const handleClose = () => {
    setShowSitePlan(false)
  }

  if (!showSitePlan) {
    return null
  }

  return (
    <ErrorBoundary>
      <div
        ref={ref}
        style={{
          zIndex: 1000,
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxHeight: '90vh',
          maxWidth: 'calc(100% - 200px)',
          marginLeft: sidebarOpen ? 44 : 0,
          webkitBoxShadow: 'rgb(0 0 0 / 15%) 0px 20px 40px 0px',
          boxShadow: 'rgb(0 0 0 / 15%) 0px 20px 40px 0px',
        }}
      >
        <div style={{height: '100%', width: '100%', position: 'relative'}}>
          <IconButton
            sx={{position: 'absolute', top: 0, right: 0}}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <svg
            id="Ebene_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x={0}
            y={0}
            viewBox="0 0 843.1 603"
            style={{
              enableBackground: 'new 0 0 843.1 603',
              width: '100%',
              maxHeight: '90vh',
            }}
            xmlSpace="preserve"
          >
            <style>
              {
                '.st0{fill:#f2f2f2}.st1{fill:#fff}.st2{fill:#f1f1f1}.st3{fill:none;stroke:#9b9b9b;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:0,3.9824}.st4{fill:#9b9b9b}.st4:hover{fill:#009FE3;stroke:#009FE3;stroke-width:2}.st5{fill:#e5e5e5}.st6{fill:none}.st7{enable-background:new}.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#1b1b1a}'
              }
            </style>
            <path className="st0" d="M-1.5-.5h843.9v602.6H-1.5V-.5z" />
            {/*<image
            style={{
              overflow: 'visible',
              opacity: 0.15,
              enableBackground: 'new',
            }}
            width={4217}
            height={2742}
            xlinkHref="41C35EB4B874D9C6.png"
            transform="translate(-77.913 -23.446) scale(.2397)"
          />*/}
            <path
              className="st1"
              d="m44.1 491.5.6-329.4H221v-57.5h98.3V78.9h42.5v26.2h156.8v57.5h117.2v177h175.3v151.9h-767z"
            />
            <path
              className="st1"
              d="M359.8 80.9v26.2h156.8v57.5h117.2v176.9h175.3v147.9h-763l.6-325.4H223v-57.5h98.2V80.9h38.6zm4-4h-46.5v25.7H219v57.5H42.7v4l-.6 325.4v4h771V337.6H637.8v-177H520.6v-57.5H363.8V76.9z"
            />
            <path
              className="st0"
              d="M57.8 163.8h117v180.3h-117V163.8zM182.3 181.1h22.3v4.2h18v41.8h-40.3v-46zM182.3 234.1h40.3v102.2H213v5l-2.5 2.8h-28.2v-110z"
            />
            <path
              className="st0"
              d="M222.6 180.5H254l2.4 2.4v44.5h-33.8v-46.9zM222.6 233.6l33.4.5v105.8l-1.9 1.8h-18.8V336l-12.7-.6V233.6zM264.9 178.6l2.6-2.2h64.6v164.3l-3.3 3.4H268l-3.2-3.2.1-162.3zM340.2 176.4h187.3v167.7h-55l-2.2-2h-2.5v-6.7h-12.1v-23.6h-9.4v32.3H340.2V176.4z"
            />
            <path
              className="st2"
              d="M536.1 176.4h89.1v164.9l-2.8 2.8h-86.5l.2-167.7zM58.1 361.4H67v-4.2h186.7l2.4 2.4v92.5H57.8l.3-90.7z"
            />
            <path
              className="st0"
              d="m265.7 360 3.4-2.8h59.7l2.6 2.6v88.6l-3 3.7h-62.7V360zM340 357.2h173.8l2.5 2.8v88.2l-2.5 2.5h-55.5v1.4H340v-94.9z"
            />
            <path
              className="st2"
              d="m524.7 359.7 2.4-2.5h99.2v18.4h6.7v67.8h-49.7v7.3h-58.6v-91z"
            />
            <path
              className="st0"
              d="M780.3 341.8h29.6v17.6h-29.6v-17.6zM748.5 374.5h30.2v7.8h31.2v76.8h-8.6v-6.7h-52.8v-77.9zM633.8 459.6h160.5V490H633.8v-30.4zM604 490v-30.4l-48.8.1v7h-8.6v-7l-128 .2v8.3h-8.1v-8.6H390V490c-.1 0 214-.8 214 0zM374.6 490v-30.4h-44.2v9h-7.8v-9h-21.8v10h-8.6v-10H159v10h-8.3v-10H141V490h233.6zM45.9 459.6h80V490h-80v-30.4zM221.9 106.6h294.7v58H221.9v-58z"
            />
            <path
              className="st1"
              d="M625.3 231.1h-42.6v-54.2h-5.1v54.2h-41.5v5.3h89.2v-5.3zM526.9 227.4h-40.1v-28.2h40.1v-3.6h-40.1v-18.7h-3.4v18.4H458v3.9h25.4v27.9h-28.2v-50.5H451v54.7h32.1v112.8h3.9V231.6h40.2l-.3-4.2zM128.4 356.5h10.9v64h79.3v-63h3.9v67.8H211V451h-3.9v-25.7h-67.8v27.2h-10.9v-96zM480.9 357.8h3.9v19.5h31.3v3.3h-31.5v27.9h31.5v2.8h-31.5v39.1h-3.3c-.1 0-.4-93.5-.4-92.6zM525 412.4h49.7V357h8.9v93.7h-8.9v-34.6H525v-3.7z"
            />
            <path className="st3" d="M223 168.5v288.7" />
            <path
              className="st1"
              d="M262.1 106.4v8.8h-18.7v7.6h109.1l10.3 8.1v33.7h15.4v-23.7h117.5l-.4 23.7h5.9l.3-29.8h-123l-20.7-17h-10.3l-5.2-5.2v-6.2H338v11.9h-70.3v-11.9h-5.6z"
            />
            <Tippy
              content={<TooltipContent id="404" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="404"
                onClick={handleOpen}
                className="st4"
                cx={616.9}
                cy={170.8}
                r={5.3}
                style={
                  tour?.context?.szene === '404'
                    ? activeStyle
                    : visited.find(el => el === '404')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="403" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="403"
                onClick={handleOpen}
                className="st4"
                cx={581}
                cy={170.8}
                r={5.3}
                style={
                  tour?.context?.szene === '403'
                    ? activeStyle
                    : visited.find(el => el === '403')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="400" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="400"
                onClick={handleOpen}
                className="st4"
                cx={531.5}
                cy={170.8}
                r={5.3}
                style={
                  tour?.context?.szene === '400'
                    ? activeStyle
                    : visited.find(el => el === '400')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="405" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="405"
                onClick={handleOpen}
                className="st4"
                cx={480.9}
                cy={170.8}
                r={5.3}
                style={
                  tour?.context?.szene === '405'
                    ? activeStyle
                    : visited.find(el => el === '405')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="208" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="208"
                onClick={handleOpen}
                className="st4"
                cx={421.4}
                cy={170.8}
                r={5.3}
                style={
                  tour?.context?.szene === '208'
                    ? activeStyle
                    : visited.find(el => el === '208')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="205" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="205"
                onClick={handleOpen}
                className="st4"
                cx={333}
                cy={171.8}
                r={5.3}
                style={
                  tour?.context?.szene === '205'
                    ? activeStyle
                    : visited.find(el => el === '205')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="107" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="107"
                onClick={handleOpen}
                className="st4"
                cx={49.6}
                cy={209.1}
                r={5.3}
                style={
                  tour?.context?.szene === '107'
                    ? activeStyle
                    : visited.find(el => el === '107')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="106" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="106"
                onClick={handleOpen}
                className="st4"
                cx={50.6}
                cy={258.8}
                r={5.3}
                style={
                  tour?.context?.szene === '106'
                    ? activeStyle
                    : visited.find(el => el === '106')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="314" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="314"
                onClick={handleOpen}
                className="st4"
                cx={483.4}
                cy={286.7}
                r={5.3}
                style={
                  tour?.context?.szene === '314'
                    ? activeStyle
                    : visited.find(el => el === '314')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="303" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="303"
                onClick={handleOpen}
                className="st4"
                cx={611}
                cy={453.4}
                r={5.3}
                style={
                  tour?.context?.szene === '303'
                    ? activeStyle
                    : visited.find(el => el === '303')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="304" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="304"
                onClick={handleOpen}
                className="st4"
                cx={580.8}
                cy={452.4}
                r={5.3}
                style={
                  tour?.context?.szene === '304'
                    ? activeStyle
                    : visited.find(el => el === '304')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="306" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="306"
                onClick={handleOpen}
                className="st4"
                cx={579.1}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '306'
                    ? activeStyle
                    : visited.find(el => el === '306')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="315" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="315"
                onClick={handleOpen}
                className="st4"
                cx={528.6}
                cy={351.1}
                r={5.3}
                style={
                  tour?.context?.szene === '315'
                    ? activeStyle
                    : visited.find(el => el === '315')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="317" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="317"
                onClick={handleOpen}
                className="st4"
                cx={484.8}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '317'
                    ? activeStyle
                    : visited.find(el => el === '317')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="201" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="201"
                onClick={handleOpen}
                className="st4"
                cx={425.1}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '201'
                    ? activeStyle
                    : visited.find(el => el === '201')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="202" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="202"
                onClick={handleOpen}
                className="st4"
                cx={335.2}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '202'
                    ? activeStyle
                    : visited.find(el => el === '202')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="209" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="209"
                onClick={handleOpen}
                className="st4"
                cx={239.2}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '209'
                    ? activeStyle
                    : visited.find(el => el === '209')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="101" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="101"
                onClick={handleOpen}
                className="st4"
                cx={202.4}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '101'
                    ? activeStyle
                    : visited.find(el => el === '101')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="102" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="102"
                onClick={handleOpen}
                className="st4"
                cx={161.1}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '102'
                    ? activeStyle
                    : visited.find(el => el === '102')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="105" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="105"
                onClick={handleOpen}
                className="st4"
                cx={50.6}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '105'
                    ? activeStyle
                    : visited.find(el => el === '105')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="103" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="103"
                onClick={handleOpen}
                className="st4"
                cx={89.1}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '103'
                    ? activeStyle
                    : visited.find(el => el === '103')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <path
              className="st5"
              d="M536.1 236.4h89.2l-.1 104.9-2.8 2.8h-86.5l.2-107.7zM57.8 163.8h52.9v82.8H57.8v-82.8z"
            />
            <path className="st6" d="M26.4 199.8h116.4v15.6H26.4v-15.6z" />
            <g className="st7">
              <path d="M78.7 209.7c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6c.3-.7.7-1.3 1.3-1.7.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6.6.4 1 1 1.3 1.7s.5 1.6.5 2.6-.2 1.8-.5 2.6-.7 1.3-1.3 1.7c-.6.4-1.2.6-2 .6s-1.4-.2-2-.6zm3.3-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3c-.3-.6-.8-.8-1.3-.8-.6 0-1 .3-1.3.8-.3.6-.5 1.3-.5 2.3s.2 1.7.5 2.3.8.8 1.3.8c.6 0 1-.3 1.3-.8zM90.6 204.3c.5.3.8.6 1.1 1.1s.4 1 .4 1.6-.1 1.2-.4 1.7-.7.9-1.2 1.1c-.5.3-1.1.4-1.8.4s-1.3-.1-1.9-.4c-.6-.3-1.1-.6-1.5-1.1l1.4-1.1c.2.3.4.5.8.6.3.2.6.2 1 .2.5 0 .9-.1 1.2-.4.3-.3.5-.7.5-1.1 0-.5-.2-.8-.5-1.1s-.7-.4-1.1-.4c-.6 0-1 .2-1.5.5l-1-.4.3-5.1h5.3v1.7H88l-.1 1.9c.4-.1.8-.2 1.2-.2.5.1 1 .3 1.5.5z" />
            </g>
            <path className="st6" d="M536 283h89.6v15.6H536V283z" />
            <g className="st7">
              <path d="M575 292.8c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6c.3-.7.7-1.3 1.3-1.7.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6s1 1 1.3 1.7.5 1.6.5 2.6-.2 1.8-.5 2.6c-.3.7-.7 1.3-1.3 1.7-.6.4-1.2.6-2 .6-.7 0-1.4-.2-2-.6zm3.3-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3c-.3-.6-.8-.8-1.3-.8-.6 0-1 .3-1.3.8s-.5 1.3-.5 2.3.2 1.7.5 2.3.8.8 1.3.8c.6 0 1-.2 1.3-.8zM582.8 292.8c-.6-.4-1-.9-1.3-1.5l1.6-.7c.3.7.8 1.1 1.7 1.1.4 0 .7-.1 1-.4.3-.2.4-.5.4-.9s-.1-.7-.4-.9-.7-.4-1.2-.4h-.6v-1.5h.8c.4 0 .7-.1.9-.3s.3-.5.3-.8-.1-.6-.4-.8c-.2-.2-.5-.3-.9-.3-.3 0-.6.1-.8.2s-.4.3-.6.6l-1.5-.8c.2-.5.6-.9 1.1-1.2s1.1-.5 1.8-.5c.6 0 1.1.1 1.6.3s.8.5 1.1.9.4.8.4 1.4c0 .5-.1.9-.3 1.2-.2.4-.5.7-.9.9.5.2.8.5 1.1.9s.4.9.4 1.4-.1 1-.4 1.4c-.3.4-.7.7-1.2 1s-1 .3-1.7.3-1.4-.2-2-.6z" />
            </g>
            <path
              className="st5"
              d="m574.3 357.4.2 55.2h-49.7l-.3-52.7 2.4-2.5h47.4zM626.3 357.2v18.4h6.7v67.8h-49.2v-86.5l42.5.3z"
            />
            <path className="st6" d="M583.4 396.1h49.7v13.2h-49.7v-13.2z" />
            <g className="st7">
              <path d="M603.5 405.9c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6.7-1.3 1.3-1.7c.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6s1 1 1.3 1.7.5 1.6.5 2.6-.2 1.8-.5 2.6c-.3.7-.7 1.3-1.3 1.7-.6.4-1.2.6-2 .6s-1.5-.2-2-.6zm3.3-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3-.8-.8-1.3-.8c-.6 0-1 .3-1.3.8-.3.6-.5 1.3-.5 2.3s.2 1.7.5 2.3c.3.6.8.8 1.3.8s.9-.3 1.3-.8zM612.4 399l-1.6 1.2-.9-1.4 2.9-2.1h1.5v9.6h-1.9V399z" />
            </g>
            <path
              className="st5"
              d="m128.4 357.5.4 94.4H58.2l-.1-90.5H67v-4.2l61.4.3z"
            />
            <path className="st6" d="M524.3 368.9h49.4v18.2h-49.4v-18.2z" />
            <g className="st7">
              <path d="M543.3 378.7c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6.7-1.3 1.3-1.7c.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6s1 1 1.3 1.7.5 1.6.5 2.6-.2 1.8-.5 2.6c-.3.7-.7 1.3-1.3 1.7-.6.4-1.2.6-2 .6s-1.4-.2-2-.6zm3.3-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3-.8-.8-1.3-.8c-.6 0-1 .3-1.3.8-.3.6-.5 1.3-.5 2.3s.2 1.7.5 2.3c.3.6.8.8 1.3.8s1-.2 1.3-.8zM550.2 378l3-3.2c.4-.5.8-.9 1-1.2s.3-.7.3-1c0-.4-.1-.7-.4-.9-.2-.2-.5-.4-.9-.4-.7 0-1.3.3-1.7 1l-1.4-1c.3-.5.7-1 1.2-1.3s1.2-.5 1.9-.5c.5 0 1 .1 1.5.3.5.2.8.6 1.1 1s.4.9.4 1.5-.1 1.1-.3 1.6-.6 1-1.3 1.7l-1.8 1.9h3.5v1.7H550l.2-1.2z" />
            </g>
            <Tippy
              content={<TooltipContent id="LO09" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="LO09"
                onClick={handleOpen}
                className="st4"
                cx={579.7}
                cy={406.1}
                r={5.3}
                style={
                  tour?.context?.szene === 'L009'
                    ? activeStyle
                    : visited.find(el => el === 'L009')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="316" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="316"
                onClick={handleOpen}
                className="st4"
                cx={519.1}
                cy={378.7}
                r={5.3}
                style={
                  tour?.context?.szene === '316'
                    ? activeStyle
                    : visited.find(el => el === '316')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <path className="st1" d="M85.2 356.6h6.7v54.5h-7l.3-54.5z" />
            <path
              className="st5"
              d="m340.2 176.4 110.8.2v54.7h7.2v104.4l-2.5-.3v-23.1h-9.4v31.8H340.2V176.4z"
            />
            <path className="st6" d="M58.2 421.2h70.3v19.7H58.2v-19.7z" />
            <g className="st7">
              <path d="M87.4 431c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6c.3-.7.7-1.3 1.3-1.7.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6s1 1 1.3 1.7.5 1.6.5 2.6-.2 1.8-.5 2.6-.7 1.3-1.3 1.7c-.6.4-1.2.6-2 .6s-1.5-.2-2-.6zm3.3-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3c-.3-.6-.8-.8-1.3-.8-.6 0-1 .3-1.3.8-.3.6-.5 1.3-.5 2.3s.2 1.7.5 2.3c.3.6.8.8 1.3.8s.9-.3 1.3-.8zM99.8 425.7c.4.2.8.6 1.1 1.1.3.5.4 1 .4 1.7 0 .6-.2 1.2-.5 1.7s-.7.9-1.2 1.1c-.5.3-1.1.4-1.8.4s-1.2-.2-1.8-.5c-.5-.3-.9-.8-1.2-1.4-.3-.6-.4-1.3-.4-2 0-1 .2-2 .6-2.8.4-.9 1-1.6 1.8-2.2s1.7-1 2.7-1.1l.6 1.5c-.9.3-1.6.6-2.2 1s-1 1-1.3 1.6c.5-.3 1.1-.4 1.8-.4.5-.1 1 0 1.4.3zm-.8 3.7c.3-.3.4-.7.4-1.1s-.1-.8-.4-1c-.3-.3-.7-.4-1.1-.4-.3 0-.6.1-.9.2-.3.2-.5.4-.7.6v.1c0 .6.2 1.1.5 1.4.3.4.7.6 1.2.6.3.1.7-.1 1-.4z" />
            </g>
            <Tippy
              content={<TooltipContent id="104.1" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="104.1"
                onClick={handleOpen}
                className="st4"
                cx={71.2}
                cy={427}
                r={5.3}
                style={
                  tour?.context?.szene === '104.1'
                    ? activeStyle
                    : visited.find(el => el === '104.1')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="104" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="104"
                onClick={handleOpen}
                className="st4"
                cx={91.2}
                cy={427}
                r={5.3}
                style={
                  tour?.context?.szene === '104'
                    ? activeStyle
                    : visited.find(el => el === '104')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="206" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="206"
                onClick={handleOpen}
                className="st4"
                cx={369.3}
                cy={197.9}
                r={5.3}
                style={
                  tour?.context?.szene === '206'
                    ? activeStyle
                    : visited.find(el => el === '206')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="207" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="207"
                onClick={handleOpen}
                className="st4"
                cx={401.8}
                cy={217.9}
                r={5.3}
                style={
                  tour?.context?.szene === '207'
                    ? activeStyle
                    : visited.find(el => el === '207')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="204" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="204"
                onClick={handleOpen}
                className="st4"
                cx={335}
                cy={244.8}
                r={5.3}
                style={
                  tour?.context?.szene === '204'
                    ? activeStyle
                    : visited.find(el => el === '204')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="203" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="203"
                onClick={handleOpen}
                className="st4"
                cx={335}
                cy={287.6}
                r={5.3}
                style={
                  tour?.context?.szene === '203'
                    ? activeStyle
                    : visited.find(el => el === '203')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="402" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="402"
                onClick={handleOpen}
                className="st4"
                cx={382.4}
                cy={269.7}
                r={5.3}
                style={
                  tour?.context?.szene === '402'
                    ? activeStyle
                    : visited.find(el => el === '402')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="401" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="401"
                onClick={handleOpen}
                className="st4"
                cx={383.3}
                cy={314.6}
                r={5.3}
                style={
                  tour?.context?.szene === '401'
                    ? activeStyle
                    : visited.find(el => el === '401')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <path className="st6" d="M340.1 259.1h118v15.6h-118v-15.6z" />
            <g className="st7">
              <path d="M393.2 268.9c-.6-.4-1-1-1.3-1.7s-.5-1.6-.5-2.6.2-1.8.5-2.6c.3-.7.7-1.3 1.3-1.7.6-.4 1.2-.6 2-.6.7 0 1.4.2 2 .6s1 1 1.3 1.7.5 1.6.5 2.6-.2 1.8-.5 2.6-.7 1.3-1.3 1.7c-.6.4-1.2.6-2 .6s-1.5-.2-2-.6zm3.2-2c.3-.5.5-1.3.5-2.3s-.2-1.8-.5-2.3c-.3-.6-.8-.8-1.3-.8-.6 0-1 .3-1.3.8-.3.6-.5 1.3-.5 2.3s.2 1.7.5 2.3c.3.6.8.8 1.3.8.6 0 1-.2 1.3-.8zM403.8 267.8h-4.1v-1.2l4.4-6.8h1.5v6.4h1.3v1.6h-1.3v1.6h-1.9v-1.6h.1zm.1-1.5v-3.4l-2.1 3.4h2.1z" />
            </g>
            <path className="st3" d="M458.4 168.5v288.7" />
            <path
              className="st8"
              d="M688.6 134.3c0 .7-.5 1.2-1.4 1.2h-.8v-2.2h.6c1-.1 1.6.2 1.6 1zm-.1-3.3c0 .7-.5 1.1-1.4 1.1h-.6v-2h.8c.8 0 1.2.3 1.2.9zm1.6 3.2c0-.8-.4-1.5-1.3-1.7.7-.3 1.1-1 1.1-1.7 0-1.2-.9-1.9-2.4-1.9-.9 0-1.8 0-2.4.1v7.7h2.1c2.1-.1 2.9-1.4 2.9-2.5zm8-.7v-4.7h-1.4v4.8c0 1.3-.5 1.8-1.6 1.8-1.2 0-1.6-.7-1.6-1.6v-4.9h-1.4v5c0 1.5.5 2.8 2.9 2.8 1.9-.1 3.1-1.1 3.1-3.2zm6.5.7c0-2.3-3-1.8-3-3.2 0-.5.4-.9 1.2-.9.4 0 .9.1 1.4.2V129c-.4-.1-.9-.1-1.3-.1-1.7 0-2.7.9-2.7 2.3 0 2.5 3 1.8 3 3.2 0 .7-.5 1-1.2 1-.5 0-1.2-.1-1.6-.3v1.4c.4.1 1 .2 1.5.2 1.6-.1 2.7-1.1 2.7-2.5zm7 2.1-.2-1.3c-.4.2-1 .3-1.5.3-1.5 0-2.2-.9-2.2-2.6 0-1.5.7-2.5 2.1-2.5.5 0 1 .1 1.5.2l.2-1.3c-.5-.1-1.1-.2-1.6-.2-2.6 0-3.8 1.7-3.8 4.1 0 1.9.9 3.7 3.5 3.7.7-.1 1.4-.2 2-.4zm7.4.3v-7.8h-1.4v3.1h-3.1v-3.1h-1.4v7.8h1.4v-3.4h3.1v3.4h1.4zM721 133.5h2.5v-1H721v1zm6.5.9v-5.5H726v5.5c0 .8-.3 1.1-.8 1.1-.3 0-.5 0-.7-.1v1.3c.3 0 .5.1.9.1 1.6-.2 2.1-1.2 2.1-2.4zm5.5-.6h-2.1l.7-2c.1-.4.3-.9.4-1.3l.3 1.2.7 2.1zm2.5 2.8-2.7-7.8h-1.6l-2.6 7.8h1.5l.5-1.6h2.9l.5 1.6h1.5zm5.5 0v-1.3h-2.6v-2.1h2.5V132h-2.5v-1.9h2.6v-1.3h-4v7.8h4zm8-7.4c-.7-.2-1.4-.3-2.2-.3-2.7 0-4.3 1.7-4.3 4s1.4 3.7 3.9 3.7c.9 0 1.9-.2 2.6-.5v-3.6h-1.5v2.6c-.3.1-.6.1-1 .1-1.6 0-2.4-.9-2.4-2.5 0-1.7 1.1-2.6 2.6-2.6.7 0 1.4.1 2 .4l.3-1.3zm6 7.4v-1.3h-2.6v-2.1h2.5V132h-2.5v-1.9h2.6v-1.3h-4v7.8h4zm5.5-5.4c0 .7-.5 1.2-1.4 1.2h-.5v-2.2h.6c.8-.1 1.3.2 1.3 1zm2 5.4-1.8-2.6c-.2-.3-.4-.6-.6-.8 1.2-.2 2-1 2-2.1 0-1.6-1.1-2.2-2.8-2.2h-2.2v7.7h1.5v-3.2h.1l2.1 3.2h1.7z"
            />
            <path
              d="M678.2 134.1c.7 0 1.3.6 1.3 1.4s-.6 1.4-1.3 1.4h-8.3c-.7 0-1.3-.6-1.3-1.4s.6-1.4 1.3-1.4h8.3zm-2.4-1.3c-.7 0-1.2-.5-1.2-1.2 0-.5.3-.9.7-1.1 1-.5 1.8-1.6 1.8-2.8 0-1.7-1.4-3.1-3-3.1-1.7 0-3 1.4-3 3.1 0 1.2.8 2.4 1.8 2.8.4.2.7.6.7 1.1 0 .7-.5 1.2-1.2 1.2-.2 0-.4 0-.6-.1-1.8-.9-3.1-2.8-3.1-5 0-3.1 2.4-5.5 5.4-5.5s5.4 2.5 5.4 5.5c0 2.2-1.2 4.1-3 5-.3.1-.5.1-.7.1zm-7 8.2c-.1-.3-.2-.5-.2-.9 0-1 .8-1.8 1.8-1.8h1.9c.7 0 1.2.6 1.2 1.2 0 .7-.5 1.2-1.2 1.2h-.9l2.5 4.4 2.7-4.4h-.9c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h1.9c1 0 1.8.8 1.8 1.8 0 .3-.1.6-.2.9l-4.3 7.5c-.2.3-.6.5-.9.5-.4 0-.7-.2-.9-.5l-4.3-7.5z"
              style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                fill: '#1491da',
              }}
            />
            <path className="st6" d="M668.6 167.3h152.3v11.9H668.6v-11.9z" />
            <g className="st7">
              <path d="M669.7 167.6h3.7c1.2 0 2 .3 2.6.9.6.6.9 1.4.9 2.4 0 1.1-.3 1.9-1 2.4s-1.5.8-2.7.8h-1.5v3.4h-1.9l-.1-9.9zm3.3 4.8c.6 0 1-.1 1.4-.4.3-.3.5-.6.5-1.1s-.1-.8-.4-1.1-.7-.4-1.3-.4h-1.4v3.1h1.2v-.1zM678.3 170.7h1.8v1c.3-.3.6-.6.9-.8.4-.2.7-.3 1.1-.3h.1v2h-.5c-.6 0-1 .2-1.3.5s-.5.8-.5 1.3v3.2h-1.8v-6.9h.2zM684.6 177.2c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.8s.2-1.3.5-1.8.7-.9 1.3-1.3c.5-.3 1.2-.5 1.9-.5s1.3.1 1.9.4 1 .7 1.3 1.2.5 1.2.5 1.8-.2 1.3-.5 1.8-.7 1-1.3 1.3-1.2.4-1.9.4c-.7.3-1.3.1-1.9-.2zm3.2-1.7c.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.3-.5s-.9.2-1.3.5c-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5 1-.1 1.3-.5zM692.8 177.3c-.5-.3-.9-.7-1.2-1.2s-.4-1.2-.4-1.8c0-.7.1-1.3.4-1.8.3-.5.7-1 1.2-1.3s1-.5 1.6-.5c.4 0 .8.1 1.2.2s.7.4.9.7v-4.3h1.8v10.3h-1.8v-.8c-.5.6-1.2 1-2.1 1-.5-.1-1.1-.3-1.6-.5zm3.3-1.8c.3-.3.5-.8.5-1.3s-.2-1-.5-1.4-.8-.5-1.3-.5-.9.2-1.3.5c-.3.4-.5.8-.5 1.4 0 .5.2 1 .5 1.3s.7.5 1.3.5c.6 0 1-.1 1.3-.5zM700.1 174.9v-4.1h1.8v3.7c0 .6.1 1 .3 1.3.2.2.5.4.9.4s.8-.2 1.1-.5c.3-.4.4-.8.4-1.5v-3.3h1.8v6.8h-1.8v-.8c-.3.3-.6.5-.9.7-.4.2-.7.2-1.1.2-1.7-.1-2.5-1.1-2.5-2.9zM708.3 167.3h1.8v6.3l2.4-2.9h2.2l-2.4 2.7 2.5 4.1h-2.1l-1.7-2.9-.9 1v1.9h-1.8v-10.2zM716.4 177.1c-.3-.4-.5-1-.5-1.7v-3.2h-.8v-1.5h.8v-2.2l1.8-.2v2.4h1.8v1.5h-1.8v2.9c0 .3 0 .5.1.7s.2.2.5.2.6-.1.9-.2l.5 1.5c-.3.1-.5.2-.8.3s-.6.1-1 .1c-.6 0-1.1-.2-1.5-.6zM721.1 169.5c-.2-.2-.3-.5-.3-.8s.1-.6.3-.8.5-.3.8-.3.6.1.8.3.3.5.3.8-.1.6-.3.8-.5.3-.8.3-.6-.1-.8-.3zm-.1 1.2h1.8v6.8H721v-6.8zM726.1 177.2c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.8s.2-1.3.5-1.8.7-.9 1.3-1.3c.6-.3 1.2-.5 1.9-.5s1.3.1 1.9.4 1 .7 1.3 1.2.5 1.2.5 1.8-.2 1.3-.5 1.8-.7 1-1.3 1.3-1.2.4-1.9.4c-.8.3-1.4.1-1.9-.2zm3.1-1.7c.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.3-.5s-1 .2-1.3.5-.5.8-.5 1.4.2 1 .5 1.4.8.5 1.3.5c.6 0 1-.1 1.3-.5zM733 170.7h1.8v.9c.3-.3.6-.6 1-.7s.8-.3 1.2-.3c.8 0 1.4.2 1.8.7s.7 1.2.7 2.2v4.1h-1.8V174c0-.6-.1-1.1-.3-1.3s-.5-.4-1-.4-.9.2-1.1.5c-.3.3-.4.8-.4 1.4v3.4H733v-6.9zM745.1 176.9c-.3-1.1-.4-2.2-.4-3.4s.1-2.4.4-3.5c.3-1.1.7-2.1 1.3-2.9l1.3.6c-.4.8-.8 1.7-1 2.7s-.4 2-.4 3c0 2 .5 4 1.4 5.7l-1.4.6c-.5-.8-.9-1.8-1.2-2.8zM749.4 172.3h-.7v-1.5h.7v-1.2c0-.8.2-1.4.6-1.8.4-.4.9-.6 1.6-.6.4 0 .7.1 1 .2.3.1.6.2.7.4l-.4 1.4c-.4-.2-.8-.3-1-.3-.5 0-.7.3-.7.9v1h1.5v1.5h-1.5v5.3h-1.8v-5.3zM753.9 170.7h1.8v1c.3-.3.6-.6.9-.8s.7-.3 1.1-.3h.1v2h-.5c-.6 0-1 .2-1.3.5s-.5.8-.5 1.3v3.2h-1.8v-6.9h.2zM765.3 174.7h-4.8c.1.4.3.7.6 1 .3.2.7.4 1.2.4.7 0 1.2-.3 1.7-.8l1.2 1.1c-.7.9-1.7 1.3-3 1.3-.7 0-1.3-.1-1.9-.4s-1-.7-1.3-1.3c-.3-.5-.5-1.2-.5-1.9s.1-1.3.4-1.8.7-1 1.2-1.2 1.1-.4 1.8-.4c.6 0 1.2.1 1.7.4.5.3.9.7 1.2 1.2s.4 1.1.4 1.8c.1.2.1.4.1.6zm-4.2-2.2c-.3.2-.5.5-.6.9h3c-.1-.4-.3-.7-.5-.9s-.6-.3-1-.3c-.3 0-.6.1-.9.3zM767 169.5c-.2-.2-.3-.5-.3-.8s.1-.6.3-.8.5-.3.8-.3.6.1.8.3.3.5.3.8-.1.6-.3.8-.5.3-.8.3-.6-.1-.8-.3zm-.1 1.2h1.8v6.8h-1.8v-6.8zM776.9 174.7h-4.8c.1.4.3.7.6 1 .3.2.7.4 1.2.4.7 0 1.2-.3 1.7-.8l1.2 1.1c-.7.9-1.7 1.3-3 1.3-.7 0-1.3-.1-1.9-.4s-1-.7-1.3-1.3c-.3-.5-.5-1.2-.5-1.9s.1-1.3.4-1.8.7-1 1.2-1.2 1.1-.4 1.8-.4c.6 0 1.2.1 1.7.4.5.3.9.7 1.2 1.2s.4 1.1.4 1.8c.2.2.1.4.1.6zm-4.2-2.2c-.3.2-.5.5-.6.9h3c-.1-.4-.3-.7-.5-.9s-.6-.3-1-.3c-.3 0-.6.1-.9.3zM784.2 169.4h-2.7v-1.8h7.5v1.8h-2.8v8.2h-2v-8.2zM790.3 177.2c-.6-.3-1-.7-1.3-1.3-.3-.5-.5-1.1-.5-1.8s.2-1.3.5-1.8.7-.9 1.3-1.3c.6-.3 1.2-.5 1.9-.5s1.3.1 1.9.4 1 .7 1.3 1.2.5 1.2.5 1.8-.2 1.3-.5 1.8-.7 1-1.3 1.3-1.2.4-1.9.4c-.7.3-1.3.1-1.9-.2zm3.2-1.7c.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.3-.5s-1 .2-1.3.5-.5.8-.5 1.4.2 1 .5 1.4.8.5 1.3.5 1-.1 1.3-.5zM797.2 174.9v-4.1h1.8v3.7c0 .6.1 1 .3 1.3.2.2.5.4.9.4s.8-.2 1.1-.5c.3-.4.4-.8.4-1.5v-3.3h1.8v6.8h-1.8v-.8c-.3.3-.6.5-.9.7-.3.2-.7.2-1.1.2-1.7-.1-2.5-1.1-2.5-2.9zM805.4 170.7h1.8v1c.3-.3.6-.6.9-.8.4-.2.7-.3 1.1-.3h.1v2h-.5c-.6 0-1 .2-1.3.5s-.5.8-.5 1.3v3.2h-1.8v-6.9h.2zM810.3 179.2c.9-1.8 1.4-3.7 1.4-5.7 0-1-.1-2-.4-3-.2-1-.6-1.9-1-2.7l1.3-.6c.6.8 1 1.8 1.3 2.9.3 1.1.4 2.2.4 3.5s-.1 2.4-.4 3.4-.7 2-1.3 2.9l-1.3-.7z" />
            </g>
            <path className="st6" d="M668.8 198h117.5v118.3H668.8V198z" />
            <g className="st7">
              <path d="M670.7 205.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM677.8 200.3l-1.3 1-.7-1.1 2.3-1.6h1.2v7.6h-1.5v-5.9z" />
            </g>
            <g className="st7">
              <path d="M686.5 198.3h1l3 7.8h-1l-.7-1.9h-3.5l-.7 1.9h-1l2.9-7.8zm1.9 5-1.4-3.9-1.4 3.9h2.8zM691.8 205.6c-.4-.4-.5-.9-.5-1.7v-3.2h.9v2.9c0 .6.1 1 .3 1.3s.5.4 1 .4c.3 0 .6-.1.8-.2.2-.2.4-.4.6-.7.1-.3.2-.7.2-1.1v-2.6h.9v5.4h-1v-.9c-.2.3-.5.6-.8.7s-.6.3-1 .3c-.6-.1-1.1-.2-1.4-.6zM697.1 205.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2.2-.1.3-.3.3-.5 0-.1 0-.3-.1-.4-.1-.1-.2-.2-.3-.2-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6-.3-.2-.4-.6-.4-1 0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.5.7c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5l.8.4.3.1c.4.2.7.3.9.4.2.1.4.3.5.4.1.2.2.4.2.7 0 .4-.2.8-.5 1.1s-.8.4-1.4.4c-1-.2-1.7-.4-2.2-.9zM704 205.9c-.3-.2-.6-.4-.8-.8v1h-.8V198h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.5 0 .9.1 1.3.4.4.2.7.6.9 1s.3.9.3 1.4-.1 1-.3 1.4-.5.7-.9 1c-.4.2-.8.3-1.3.3-.5-.1-.9-.1-1.2-.3zm2-.8c.3-.2.5-.4.6-.7.2-.3.2-.6.2-1s-.1-.7-.2-1c-.2-.3-.4-.5-.7-.7s-.6-.2-.9-.2c-.4 0-.7.1-.9.3-.3.2-.5.4-.6.7-.2.3-.2.6-.2 1s.1.7.2 1 .4.5.7.7.6.2.9.2c.3-.1.6-.1.9-.3zM709.2 199.6c-.1-.1-.2-.3-.2-.5s.1-.3.2-.5.3-.2.5-.2.3.1.5.2c.1.1.2.3.2.5s-.1.3-.2.5c-.1.1-.3.2-.5.2s-.4-.1-.5-.2zm0 1.1h.9v5.4h-.9v-5.4zM711.9 198h.9v8.1h-.9V198zM715.4 205.8c-.4-.2-.7-.5-.9-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.8.9-1 .8-.4 1.3-.4c.4 0 .8.1 1.1.3s.6.4.8.8V198h.9v8.1h-.9v-1c-.2.3-.5.6-.8.8s-.7.3-1.1.3c-.4-.1-.9-.2-1.3-.4zm2.4-.7c.3-.2.5-.4.7-.7s.2-.6.2-1-.1-.7-.2-1-.4-.5-.6-.7c-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.2s-.5.4-.7.7-.2.6-.2 1 .1.7.2 1c.2.3.4.5.6.7.3.2.6.2 1 .2.2.1.5.1.8-.1zM721.6 205.6c-.4-.4-.5-.9-.5-1.7v-3.2h.9v2.9c0 .6.1 1 .3 1.3s.5.4 1 .4c.3 0 .6-.1.8-.2.2-.2.4-.4.6-.7.1-.3.2-.7.2-1.1v-2.6h.9v5.4h-.9v-.9c-.2.3-.5.6-.8.7s-.6.3-1 .3c-.6-.1-1.1-.2-1.5-.6zM727.4 200.7h.9v1c.2-.3.5-.6.8-.8s.7-.3 1.1-.3c.6 0 1.1.2 1.4.6s.5.9.5 1.7v3.2h-.9v-2.9c0-1.1-.4-1.7-1.3-1.7-.5 0-.9.2-1.2.5s-.5.8-.5 1.4v2.7h-.9v-5.4h.1zM733.9 207.7l.2-.8c.3.2.7.3.9.4.3.1.6.1 1 .1.6 0 1-.1 1.3-.4.3-.3.5-.7.5-1.2v-.8c-.2.3-.5.5-.8.7s-.7.2-1.1.2c-.5 0-.9-.1-1.3-.3-.4-.2-.7-.5-.9-.9s-.3-.9-.3-1.4.1-1 .3-1.4.5-.7.9-1c.4-.2.8-.3 1.3-.3.4 0 .7.1 1.1.2s.6.4.8.7v-.9h.9v5c0 .8-.2 1.5-.6 1.9-.4.5-1.1.7-2 .7-.8.1-1.5-.1-2.2-.5zm3.1-2.8c.3-.2.5-.4.6-.7s.2-.6.2-1-.1-.7-.2-.9c-.2-.3-.4-.5-.6-.6-.3-.2-.6-.2-.9-.2-.4 0-.7.1-1 .2-.3.2-.5.4-.6.7-.2.3-.2.6-.2.9 0 .4.1.7.2 1 .2.3.4.5.6.6.3.2.6.2.9.2.5.1.8 0 1-.2z" />
            </g>
            <g className="st7">
              <path d="M670.7 225.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM676.1 225.1l2.3-2.5c.3-.4.6-.7.8-.9s.2-.5.2-.8-.1-.5-.3-.7-.4-.3-.7-.3c-.6 0-1 .3-1.3.8l-1.1-.8c.2-.4.6-.8 1-1 .4-.3.9-.4 1.5-.4.4 0 .8.1 1.2.3s.7.4.9.8c.2.3.3.7.3 1.2 0 .4-.1.9-.3 1.2-.2.4-.5.8-1 1.3l-1.4 1.5h2.7v1.4H676l.1-1.1z" />
            </g>
            <g className="st7">
              <path d="M685.5 218.3h2.6c.8 0 1.4.2 1.9.5.4.3.7.8.7 1.4 0 .4-.1.8-.3 1.1s-.5.6-.9.7c.5.1.9.3 1.2.7s.5.8.5 1.3c0 .6-.2 1.2-.7 1.5-.4.4-1.1.6-1.9.6h-2.8v-7.8h-.3zm2.5 3.3c.4 0 .8-.1 1.1-.3s.4-.5.4-1c0-.4-.1-.7-.4-.9-.3-.2-.7-.3-1.2-.3h-1.5v2.5h1.6zm.2 3.6c.5 0 .9-.1 1.2-.3s.5-.6.5-1-.2-.8-.5-1-.8-.4-1.4-.4h-1.7v2.7h1.9zM692.7 225.6c-.4-.4-.5-.9-.5-1.7v-3.2h.9v2.9c0 .6.1 1 .3 1.3s.5.4 1 .4c.3 0 .6-.1.8-.2.2-.2.4-.4.6-.7.1-.3.2-.7.2-1.1v-2.6h.9v5.4h-.9v-.9c-.2.3-.5.6-.8.7s-.6.3-1 .3c-.6-.1-1.1-.2-1.5-.6zM698 225.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2.2-.1.3-.3.3-.5 0-.1 0-.3-.1-.4-.1-.1-.2-.2-.3-.2-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6-.3-.2-.4-.6-.4-1 0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.5.7c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5l.8.4.3.1c.4.2.7.3.9.4.2.1.4.3.5.4.1.2.2.4.2.7 0 .4-.2.8-.5 1.1s-.8.4-1.4.4c-.9-.2-1.6-.4-2.2-.9zM704.3 225.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2s.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.5 0-1 .2-1.3.5s-.5.8-.5 1.4.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.6.1-1 0-1.4-.2zM709.1 218h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.8v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9l.1-8zM715.2 222.3h3.3v.9h-3.3v-.9zM719.9 224.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8h-1.8v2.9c0 .3 0 .6.1.7s.3.2.5.2c.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2s-.4.1-.7.1c-.9 0-1.3-.5-1.3-1.6zM724.4 225.8c-.4-.2-.7-.5-.9-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.8.9-1 .8-.4 1.3-.4c.4 0 .8.1 1.1.3s.6.4.8.8v-.9h.9v5.4h-.9v-1c-.2.3-.5.6-.8.8s-.7.3-1.1.3c-.5-.2-.9-.3-1.3-.5zm2.4-.7c.3-.2.5-.4.6-.7s.2-.6.2-1-.1-.7-.2-1c-.2-.3-.4-.5-.6-.7-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.2-.3.2-.5.4-.7.7s-.2.6-.2 1 .1.7.2 1c.2.3.4.5.6.7s.6.2 1 .2c.3.1.6.1.9-.1zM731.1 225.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2.4.2.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.6 0-1 .2-1.3.5-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.6.1-1 0-1.4-.2zM736 224.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8h-1.8v2.9c0 .3 0 .6.1.7s.3.2.5.2c.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2s-.4.1-.7.1c-.9 0-1.3-.5-1.3-1.6zM744.3 223.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3s-.7-.5-1-1c-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1s-.6-.4-1.1-.4-.7.1-1.1.4zM746.6 225.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.6-.7 1-1c.4-.2.9-.4 1.4-.4s1 .1 1.4.3.8.6 1 1 .4.9.4 1.4-.1 1-.4 1.4c-.2.4-.6.7-1 1-.4.2-.9.3-1.4.3-.5.1-1 0-1.4-.2zm2.4-.7c.3-.2.5-.4.7-.7s.2-.6.2-1-.1-.7-.2-1-.4-.5-.7-.7-.6-.2-.9-.2c-.4 0-.7.1-1 .3s-.5.4-.7.7-.2.6-.2 1 .1.7.2 1c.2.3.4.5.7.7s.6.3 1 .3c.3-.2.6-.2.9-.4zM756.9 219.7c.5.3.9.7 1.2 1.2s.4 1.1.4 1.7c0 .6-.1 1.2-.4 1.7-.3.5-.7.9-1.2 1.2s-1.1.5-1.7.5c-.6 0-1.2-.2-1.7-.5s-.9-.7-1.2-1.2-.4-1.1-.4-1.7.1-1.2.4-1.7c.3-.5.7-.9 1.2-1.2s1.1-.5 1.7-.5 1.2.2 1.7.5zm-.4 5.2c.4-.2.7-.6 1-1s.4-.9.4-1.4-.1-.9-.4-1.4-.6-.8-1-1-.9-.4-1.4-.4-1 .1-1.4.4c-.4.2-.7.6-1 1s-.4.9-.4 1.4.1.9.4 1.4.6.8 1 1 .9.4 1.4.4c.6 0 1-.1 1.4-.4zm-.2-2.3c-.1.2-.3.3-.6.4l.9 1.4h-.6l-.9-1.3h-.5v1.3h-.6v-3.6h1.3c.4 0 .7.1.9.3s.3.5.3.8-.1.5-.2.7zm-1.7-.1h.6c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4s-.3-.2-.5-.2h-.6l-.1 1.2z" />
            </g>
            <g className="st7">
              <path d="M670.7 245.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM676.8 245.7c-.5-.3-.8-.7-1-1.2l1.3-.5c.2.6.7.9 1.3.9.3 0 .6-.1.8-.3s.3-.4.3-.7-.1-.5-.3-.7-.5-.3-.9-.3h-.5v-1.2h.7c.3 0 .6-.1.7-.3.2-.2.2-.4.2-.6 0-.3-.1-.5-.3-.7s-.4-.3-.7-.3-.5.1-.7.2c-.2.1-.3.3-.4.5l-1.2-.6c.2-.4.5-.7.9-1s.9-.4 1.4-.4.9.1 1.2.2c.4.2.7.4.9.7s.3.7.3 1.1c0 .4-.1.7-.3 1s-.4.5-.7.7c.4.2.7.4.9.7s.3.7.3 1.1c0 .4-.1.8-.3 1.1s-.5.6-.9.8-.8.3-1.3.3c-.6 0-1.2-.2-1.7-.5z" />
            </g>
            <g className="st7">
              <path d="M685.7 238.3h1v6.9h3.9v.9h-4.8v-7.8h-.1zM691.7 239.6c-.1-.1-.2-.3-.2-.5s.1-.3.2-.5.3-.2.5-.2.3.1.5.2c.1.1.2.3.2.5s-.1.3-.2.5c-.1.1-.3.2-.5.2s-.3-.1-.5-.2zm0 1.1h.9v5.4h-.9v-5.4zM695.3 245.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2s.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.5 0-1 .2-1.3.5s-.5.8-.5 1.4.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.5.1-1 0-1.4-.2zM700.1 238h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.8v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9l.1-8zM706.6 244.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8h-1.8v2.9c0 .3 0 .6.1.7s.3.2.5.2c.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2s-.4.1-.7.1c-.8 0-1.3-.5-1.3-1.6zM710 245.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2.2-.1.3-.3.3-.5 0-.1 0-.3-.1-.4-.1-.1-.2-.2-.3-.2-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6-.3-.2-.4-.6-.4-1 0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.5.7c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5l.8.4.3.1c.4.2.7.3.9.4.2.1.4.3.5.4.1.2.2.4.2.7 0 .4-.2.8-.5 1.1s-.8.4-1.4.4c-.9-.2-1.6-.4-2.2-.9zM716.2 245.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2.4.2.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.6 0-1 .2-1.3.5-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.5.1-1 0-1.4-.2zM721 238h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.9v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.7v-8zM728.3 245.8c-.4-.2-.7-.5-.9-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.8.9-1 .8-.4 1.3-.4c.4 0 .8.1 1.1.3s.6.4.8.8v-.9h.9v5.4h-.9v-1c-.2.3-.5.6-.8.8s-.7.3-1.1.3c-.4-.2-.9-.3-1.3-.5zm2.4-.7c.3-.2.5-.4.6-.7s.2-.6.2-1-.1-.7-.2-1c-.2-.3-.4-.5-.6-.7-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.2-.3.2-.5.4-.7.7s-.2.6-.2 1 .1.7.2 1c.2.3.4.5.6.7s.6.2 1 .2c.3.1.6.1.9-.1zM734.1 238h.9v8.1h-.9V238zM736.9 244.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8h-1.8v2.9c0 .3 0 .6.1.7.1.2.3.2.5.2.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2-.2.1-.4.1-.7.1-.9 0-1.3-.5-1.3-1.6zM745.2 243.5v.1H741c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3s-.7-.5-1-1c-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1s-.6-.4-1.1-.4-.8.1-1.1.4zM746.5 240.7h.9v1c.2-.3.4-.6.7-.8s.6-.3 1-.3h.2v1h-.4c-.5 0-.9.2-1.2.5s-.4.8-.4 1.3v2.6h-.9v-5.3h.1z" />
            </g>
            <g className="st7">
              <path d="M670.7 265.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM679.1 264.8h-3.2v-.9l3.5-5.4h1.2v5h1v1.3h-1v1.2h-1.5v-1.2zm.1-1.2v-2.7l-1.7 2.7h1.7z" />
            </g>
            <g className="st7">
              <path d="M686.8 265.8c-.5-.2-.9-.5-1.3-.9l.6-.7c.3.3.6.6 1 .8.4.2.8.3 1.2.3.5 0 .9-.1 1.2-.3.3-.2.4-.5.4-.9 0-.3-.1-.5-.2-.7-.1-.2-.3-.3-.5-.4s-.6-.2-1-.4c-.5-.2-.9-.4-1.2-.5-.3-.2-.6-.4-.8-.7-.2-.3-.3-.6-.3-1.1 0-.4.1-.7.3-1s.5-.6.9-.7c.4-.2.8-.3 1.2-.3s.9.1 1.3.2c.4.2.8.4 1.2.7l-.6.8c-.3-.3-.6-.5-1-.6s-.6-.2-.9-.2c-.4 0-.7.1-1 .3-.3.2-.4.5-.4.9 0 .2.1.4.2.6.1.2.3.3.5.4s.5.2.9.4c0 0 .1 0 .2.1.5.2.9.4 1.2.6s.5.4.7.6c.2.3.3.6.3 1.1s-.1.9-.4 1.2-.6.6-1 .8c-.4.2-.8.3-1.3.3-.5-.4-1-.5-1.4-.7zM692.4 264.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8h-1.8v2.9c0 .3 0 .6.1.7.1.2.3.2.5.2.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2-.2.1-.4.1-.7.1-.9 0-1.3-.5-1.3-1.6zM700.7 263.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.8.1-1.1.4zM703 265.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2.4.2.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.6 0-1 .2-1.3.5-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.6.1-1 0-1.4-.2zM707.8 258h.9v5.7l2.6-2.9h1.1l-2 2.2 2 3.1h-1l-1.6-2.5-1.1 1.2v1.3h-.9V258zM714.1 265.8c-.4-.2-.7-.5-.9-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.8.9-1 .8-.4 1.3-.4c.4 0 .8.1 1.1.3.3.2.6.4.8.8V258h.9v8.1h-.9v-1c-.2.3-.5.6-.8.8-.3.2-.7.3-1.1.3-.4-.1-.9-.2-1.3-.4zm2.4-.7c.3-.2.5-.4.7-.7s.2-.6.2-1-.1-.7-.2-1-.4-.5-.6-.7c-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.2s-.5.4-.7.7c-.2.3-.2.6-.2 1s.1.7.2 1c.2.3.4.5.6.7.3.2.6.2 1 .2.2.1.5.1.8-.1zM720.9 265.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.6-.7 1-1c.4-.2.9-.4 1.4-.4s1 .1 1.4.3c.4.2.8.6 1 1s.4.9.4 1.4-.1 1-.4 1.4c-.2.4-.6.7-1 1-.4.2-.9.3-1.4.3-.5.1-1 0-1.4-.2zm2.4-.7c.3-.2.5-.4.7-.7s.2-.6.2-1-.1-.7-.2-1-.4-.5-.7-.7-.6-.2-.9-.2c-.4 0-.7.1-1 .3-.3.2-.5.4-.7.7-.2.3-.2.6-.2 1s.1.7.2 1c.2.3.4.5.7.7s.6.3 1 .3c.3-.2.6-.2.9-.4zM726 265.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2.2-.1.3-.3.3-.5 0-.1 0-.3-.1-.4s-.2-.2-.3-.2c-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6s-.4-.6-.4-1c0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.5.7c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5l.8.4.3.1c.4.2.7.3.9.4s.4.3.5.4c.1.2.2.4.2.7 0 .4-.2.8-.5 1.1s-.8.4-1.4.4c-1-.2-1.7-.4-2.2-.9zM736 263.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.8.1-1.1.4zM737.3 260.7h.9v1c.2-.3.5-.6.8-.8.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.6s.5.9.5 1.7v3.2h-.9v-2.9c0-1.1-.4-1.7-1.3-1.7-.5 0-.9.2-1.2.5s-.5.8-.5 1.4v2.7h-.9v-5.4h.1z" />
            </g>
            <g className="st7">
              <path d="M670.7 285.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM680 281.5c.4.2.6.5.9.8.2.4.3.8.3 1.3s-.1.9-.3 1.3-.5.7-1 .9c-.4.2-.9.3-1.4.3s-1-.1-1.5-.3c-.5-.2-.8-.5-1.2-.9l1.1-.9c.2.2.4.4.6.5.2.1.5.2.8.2.4 0 .7-.1 1-.3.2-.2.4-.5.4-.9s-.1-.7-.4-.9-.6-.3-.9-.3c-.4 0-.8.1-1.1.4l-.8-.3.2-4h4.1v1.4H678l-.1 1.5c.4-.1.7-.2.9-.2.5.1.9.2 1.2.4z" />
            </g>
            <g className="st7">
              <path d="M685.8 278.3h2.6c.8 0 1.4.2 1.9.5.4.3.7.8.7 1.4 0 .4-.1.8-.3 1.1s-.5.6-.9.7c.5.1.9.3 1.2.7s.5.8.5 1.3c0 .6-.2 1.2-.7 1.5-.4.4-1.1.6-1.9.6h-2.8v-7.8h-.3zm2.5 3.3c.4 0 .8-.1 1.1-.3s.4-.5.4-1c0-.4-.1-.7-.4-.9-.3-.2-.7-.3-1.2-.3h-1.5v2.5h1.6zm.2 3.6c.5 0 .9-.1 1.2-.3s.5-.6.5-1-.2-.8-.5-1-.8-.4-1.4-.4h-1.7v2.7h1.9zM693 285.6c-.4-.4-.5-.9-.5-1.7v-3.2h.9v2.9c0 .6.1 1 .3 1.3s.5.4 1 .4c.3 0 .6-.1.8-.2.2-.2.4-.4.6-.7.1-.3.2-.7.2-1.1v-2.6h.9v5.4h-.9v-.9c-.2.3-.5.6-.8.7s-.6.3-1 .3c-.6-.1-1.1-.2-1.5-.6zM698.3 285.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2.2-.1.3-.3.3-.5 0-.1 0-.3-.1-.4s-.2-.2-.3-.2c-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6s-.4-.6-.4-1c0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.5.7c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5l.8.4.3.1c.4.2.7.3.9.4s.4.3.5.4c.1.2.2.4.2.7 0 .4-.2.8-.5 1.1s-.8.4-1.4.4c-.9-.2-1.6-.4-2.2-.9zM704.6 285.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2s.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.5 0-1 .2-1.3.5s-.5.8-.5 1.4.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.6.1-1 0-1.4-.2zM709.4 278h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.9v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9v-8h.2zM715.5 282.3h3.3v.9h-3.3v-.9zM719.2 278.3h1l2 6.3 1.8-6.3h1l1.7 6.3 2-6.3h1l-2.5 7.8h-.9l-1.8-6.4-1.9 6.4h-.9l-2.5-7.8zM731.1 285.8c-.4-.2-.7-.5-.9-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.8.9-1 .8-.4 1.3-.4c.4 0 .8.1 1.1.3.3.2.6.4.8.8v-.9h.9v5.4h-.9v-1c-.2.3-.5.6-.8.8s-.7.3-1.1.3c-.4-.2-.9-.3-1.3-.5zm2.4-.7c.3-.2.5-.4.6-.7s.2-.6.2-1-.1-.7-.2-1-.4-.5-.6-.7c-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.2-.3.2-.5.4-.7.7-.2.3-.2.6-.2 1s.1.7.2 1 .4.5.6.7c.3.2.6.2 1 .2.3.1.6.1.9-.1zm-2.3-5.6c-.1-.1-.2-.3-.2-.5s.1-.3.2-.4c.1-.1.3-.2.5-.2s.3.1.5.2.2.3.2.4c0 .2-.1.3-.2.4-.1.1-.3.2-.5.2-.2.1-.4.1-.5-.1zm2 0c-.1-.1-.2-.3-.2-.5s.1-.3.2-.4c.1-.1.3-.2.5-.2s.3.1.5.2c.1.1.2.3.2.4 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2s-.4.1-.5-.1zM737.8 285.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2.4.2.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.6 0-1 .2-1.3.5-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.5.1-1 0-1.4-.2zM742.6 278h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.9v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9v-8h.2zM749.1 284.5v-3h-.7v-.8h.7v-1.8l.9-.1v1.9h1.8v.8H750v2.9c0 .3 0 .6.1.7s.3.2.5.2c.3 0 .6-.1.9-.3l.2.8c-.2.1-.4.2-.6.2s-.4.1-.7.1c-.8 0-1.3-.5-1.3-1.6zM757.5 283.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.8.1-1.1.4zM758.8 280.7h.9v1c.2-.3.4-.6.7-.8.3-.2.6-.3 1-.3h.2v1h-.4c-.5 0-.9.2-1.2.5s-.4.8-.4 1.3v2.6h-.9v-5.3h.1zM767.4 279.7c.5.3.9.7 1.2 1.2s.4 1.1.4 1.7-.1 1.2-.4 1.7c-.3.5-.7.9-1.2 1.2-.5.3-1.1.5-1.7.5-.6 0-1.2-.2-1.7-.5s-.9-.7-1.2-1.2-.4-1.1-.4-1.7.1-1.2.4-1.7c.3-.5.7-.9 1.2-1.2.5-.3 1.1-.5 1.7-.5.6 0 1.2.2 1.7.5zm-.4 5.2c.4-.2.7-.6 1-1 .2-.4.4-.9.4-1.4s-.1-.9-.4-1.4-.6-.8-1-1-.9-.4-1.4-.4-1 .1-1.4.4c-.4.2-.7.6-1 1-.2.4-.4.9-.4 1.4s.1.9.4 1.4c.2.4.6.8 1 1s.9.4 1.4.4c.6 0 1-.1 1.4-.4zm-.2-2.3c-.1.2-.3.3-.6.4l.9 1.4h-.7l-.9-1.3h-.5v1.3h-.6v-3.6h1.3c.4 0 .7.1.9.3s.3.5.3.8c.1.3 0 .5-.1.7zm-1.7-.1h.6c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4s-.3-.2-.5-.2h-.6l-.1 1.2z" />
            </g>
            <g className="st7">
              <path d="M670.7 305.7c-.4-.3-.8-.8-1-1.3-.2-.6-.4-1.3-.4-2.1s.1-1.4.4-2 .6-1 1-1.4c.4-.3 1-.5 1.6-.5s1.1.2 1.5.5.8.8 1 1.3c.2.6.4 1.3.4 2.1s-.1 1.4-.4 2-.6 1-1 1.4c-.4.3-1 .5-1.6.5-.5 0-1-.2-1.5-.5zm2.6-1.6c.2-.4.4-1 .4-1.8s-.1-1.4-.4-1.8c-.2-.4-.6-.7-1-.7s-.8.2-1 .6c-.3.4-.4 1-.4 1.8s.1 1.4.4 1.8c.3.4.6.7 1 .7.4.1.8-.1 1-.6zM680.5 301.5c.4.2.6.5.8.8.2.4.3.8.3 1.3s-.1.9-.4 1.3c-.2.4-.6.7-1 .9-.4.2-.9.3-1.4.3s-1-.1-1.4-.4-.7-.6-1-1.1-.4-1-.4-1.6c0-.8.2-1.5.5-2.2s.8-1.2 1.4-1.7c.6-.5 1.3-.8 2.1-.9l.4 1.2c-.7.2-1.3.5-1.7.8s-.8.8-1 1.3c.4-.2.9-.3 1.4-.3.7 0 1.1.1 1.4.3zm-.6 3c.2-.2.3-.5.3-.8s-.1-.6-.3-.8c-.2-.2-.5-.3-.9-.3-.2 0-.5.1-.7.2s-.4.3-.6.5v.1c0 .5.1.8.4 1.1.3.3.6.4 1 .4.3-.1.6-.2.8-.4z" />
            </g>
            <g className="st7">
              <path d="M686.1 298.3h2.6c.8 0 1.4.2 1.9.5.4.3.7.8.7 1.4 0 .4-.1.8-.3 1.1-.2.3-.5.6-.9.7.5.1.9.3 1.2.7.3.3.5.8.5 1.3 0 .6-.2 1.2-.7 1.5-.4.4-1.1.6-1.9.6h-2.8v-7.8h-.3zm2.5 3.3c.4 0 .8-.1 1.1-.3.3-.2.4-.5.4-1 0-.4-.1-.7-.4-.9-.3-.2-.7-.3-1.2-.3H687v2.5h1.6zm.2 3.6c.5 0 .9-.1 1.2-.3.3-.2.5-.6.5-1s-.2-.8-.5-1-.8-.4-1.4-.4H687v2.7h1.8zM693.3 305.6c-.4-.4-.5-.9-.5-1.7v-3.2h.9v2.9c0 .6.1 1 .3 1.3s.5.4 1 .4c.3 0 .6-.1.8-.2.2-.2.4-.4.6-.7.1-.3.2-.7.2-1.1v-2.6h.9v5.4h-.9v-.9c-.2.3-.5.6-.8.7s-.6.3-1 .3c-.6-.1-1.1-.2-1.5-.6zM698.6 305.4l.5-.7c.2.2.5.4.7.5.3.1.6.2.9.2.3 0 .6-.1.7-.2s.3-.3.3-.5c0-.1 0-.3-.1-.4s-.2-.2-.3-.2c-.1-.1-.4-.2-.8-.3-.5-.2-.9-.4-1.2-.6s-.4-.6-.4-1c0-.3.1-.5.2-.7.2-.2.4-.4.6-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.8.7l-.4.5c-.4-.4-.9-.6-1.4-.6-.2 0-.4.1-.6.2s-.2.3-.2.5.1.3.3.5.4.2.8.4l.3.1c.4.2.7.3.9.4s.4.3.5.4c.1.2.2.4.2.7 0 .4-.2.8-.5 1.1-.3.3-.8.4-1.4.4-1 0-1.7-.2-2.3-.7zM704.9 305.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7 1-1c.4-.2.9-.4 1.4-.4.4 0 .8.1 1.2.2.4.2.7.4 1 .7l-.6.5c-.2-.2-.4-.4-.7-.5s-.5-.2-.9-.2c-.6 0-1 .2-1.3.5-.3.4-.5.8-.5 1.4s.2 1 .5 1.4.8.5 1.3.5c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5l.6.6c-.2.3-.5.5-.9.7s-.8.3-1.3.3c-.6.1-1 0-1.4-.2zM709.7 298h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.9v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9v-8h.2zM715.8 302.3h3.3v.9h-3.3v-.9zM720.7 301.5h-.6v-.8h.6v-1.1c0-.6.1-1 .4-1.3.3-.3.6-.4 1.1-.4s.9.1 1.2.4l-.2.8c-.4-.2-.7-.3-.9-.3-.5 0-.7.3-.7 1v1h1.5v.8h-1.5v4.6h-.9v-4.7zM724.2 300.7h.9v1c.2-.3.4-.6.7-.8.3-.2.6-.3 1-.3h.2v1h-.4c-.5 0-.9.2-1.2.5s-.4.8-.4 1.3v2.6h-.9v-5.3h.1zM732.6 303.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.7.1-1.1.4zM738.7 303.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.8.1-1.1.4zM741.7 307.1c-.6-.3-1.1-.8-1.5-1.5-.4-.6-.5-1.3-.5-2.2 0-.7.2-1.4.5-2.1s.8-1.3 1.6-1.8 1.6-.7 2.7-.7c.8 0 1.5.2 2.1.5s1.1.8 1.4 1.4.5 1.3.5 2.1c0 .4-.1.8-.2 1.2s-.4.8-.7 1.1c-.3.3-.8.5-1.3.5-.2 0-.4-.1-.6-.2s-.3-.2-.3-.4c-.1-.1-.1-.3-.2-.5-.2.3-.4.5-.7.7s-.6.2-1 .2-.7-.1-1-.3c-.3-.2-.5-.4-.7-.7-.2-.3-.2-.7-.2-1.1s.1-.7.2-1.1c.2-.4.4-.7.7-1s.7-.4 1.2-.4c.3 0 .6.1.9.3s.5.4.6.7l.1-.9h.9l-.3 3v.3c0 .2 0 .4.1.5s.2.1.4.1c.3 0 .5-.1.7-.3s.3-.5.4-.8c.1-.3.1-.6.1-.9 0-.6-.1-1.2-.4-1.7s-.7-.9-1.2-1.2-1.1-.4-1.7-.4c-.9 0-1.6.2-2.2.6s-1.1.9-1.4 1.5c-.3.6-.5 1.2-.5 1.9 0 .6.1 1.2.4 1.7.3.5.7.9 1.2 1.3s1.1.5 1.8.5c.5 0 .9 0 1.2-.1s.7-.2 1.1-.4l.3.5c-.7.5-1.6.7-2.6.7-.6-.1-1.3-.3-1.9-.6zm2.9-2.7c.2-.2.4-.4.5-.6.1-.3.2-.5.2-.8 0-.4-.1-.7-.3-.9-.2-.2-.5-.4-.9-.4-.3 0-.6.1-.8.2-.2.2-.4.3-.5.6-.1.2-.2.5-.2.8 0 .4.1.7.3 1s.5.4.9.4c.3 0 .6-.1.8-.3zM749.9 298h.9v3.7c.2-.3.5-.6.8-.7.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.5.3.4.5.9.5 1.7v3.2h-.9v-3c0-1.1-.4-1.7-1.3-1.7-.5 0-1 .2-1.3.5s-.5.8-.5 1.4v2.7h-.9v-8h.2zM757.3 305.8c-.4-.2-.7-.6-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.6-.7 1-1c.4-.2.9-.4 1.4-.4s1 .1 1.4.3c.4.2.8.6 1 1s.4.9.4 1.4-.1 1-.4 1.4c-.2.4-.6.7-1 1-.4.2-.9.3-1.4.3-.5.1-1 0-1.4-.2zm2.4-.7c.3-.2.5-.4.7-.7s.2-.6.2-1-.1-.7-.2-1c-.2-.3-.4-.5-.7-.7s-.6-.2-.9-.2c-.4 0-.7.1-1 .3-.3.2-.5.4-.7.7-.2.3-.2.6-.2 1s.1.7.2 1c.2.3.4.5.7.7s.6.3 1 .3c.3-.2.6-.2.9-.4zM762.8 300.7h.9v1c.2-.3.5-.6.8-.8.3-.2.7-.3 1-.3.4 0 .7.1 1 .3s.5.5.6.8c.2-.4.5-.6.8-.8.3-.2.7-.3 1.1-.3.6 0 1.1.2 1.4.6.3.4.5 1 .5 1.7v3.1h-.9v-2.8c0-.6-.1-1-.3-1.3s-.5-.5-.9-.5c-.3 0-.5.1-.8.2-.2.2-.4.4-.5.7-.1.3-.2.6-.2 1v2.7h-.9v-2.8c0-.6-.1-1-.3-1.3s-.5-.5-.9-.5-.8.2-1.1.5c-.3.4-.4.8-.4 1.4v2.7h-.9v-5.3zM777.3 303.5v.1h-4.2c.1.5.3.9.6 1.2s.7.5 1.3.5 1.2-.2 1.6-.7l.6.5c-.5.7-1.3 1-2.2 1-.5 0-1-.1-1.4-.3-.4-.2-.7-.5-1-1-.2-.4-.3-.9-.3-1.4s.1-1 .3-1.4.5-.7.9-1c.4-.2.9-.4 1.4-.4s.9.1 1.3.3.7.5.9.9.3.9.3 1.4c-.1.2-.1.3-.1.3zm-3.6-1.6c-.3.3-.5.6-.6 1.1h3.3c-.1-.4-.2-.8-.5-1.1-.3-.3-.6-.4-1.1-.4s-.8.1-1.1.4z" />
            </g>
            <Tippy
              content={<TooltipContent id="301" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="301"
                onClick={handleOpen}
                className="st4"
                cx={620.7}
                cy={515.3}
                r={5.3}
                style={
                  tour?.context?.szene === '301'
                    ? activeStyle
                    : visited.find(el => el === '301')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="307" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="307"
                onClick={handleOpen}
                className="st4"
                cx={630.4}
                cy={350.1}
                r={5.3}
                style={
                  tour?.context?.szene === '307'
                    ? activeStyle
                    : visited.find(el => el === '307')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="308a" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="308a"
                onClick={handleOpen}
                className="st4"
                cx={630.4}
                cy={268.8}
                r={5.3}
                style={
                  tour?.context?.szene === '308a'
                    ? activeStyle
                    : visited.find(el => el === '308a')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="308" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="308"
                onClick={handleOpen}
                className="st4"
                cx={630.4}
                cy={312.4}
                r={5.3}
                style={
                  tour?.context?.szene === '308'
                    ? activeStyle
                    : visited.find(el => el === '308')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="311" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="311"
                onClick={handleOpen}
                className="st4"
                cx={529.2}
                cy={233.6}
                r={5.3}
                style={
                  tour?.context?.szene === '311'
                    ? activeStyle
                    : visited.find(el => el === '311')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="310" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="310"
                onClick={handleOpen}
                className="st4"
                cx={578.6}
                cy={233.6}
                r={5.3}
                style={
                  tour?.context?.szene === '310'
                    ? activeStyle
                    : visited.find(el => el === '310')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="309" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="309"
                onClick={handleOpen}
                className="st4"
                cx={630.4}
                cy={233.6}
                r={5.3}
                style={
                  tour?.context?.szene === '309'
                    ? activeStyle
                    : visited.find(el => el === '309')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
            <Tippy
              content={<TooltipContent id="302" />}
              arrow={false}
              delay={[0, 0]}
              followCursor={true}
            >
              <circle
                id="302"
                onClick={handleOpen}
                className="st4"
                cx={620.3}
                cy={475.3}
                r={5.3}
                style={
                  tour?.context?.szene === '302'
                    ? activeStyle
                    : visited.find(el => el === '302')
                    ? visitedStyle
                    : defaultStyle
                }
              />
            </Tippy>
          </svg>{' '}
        </div>
      </div>
      )
    </ErrorBoundary>
  )
}
